export default "assets/images/logo-picto-e08ed713.png";